import { CTX_SUBSCRIBE_TAGNAME } from "@acng/frontend-relativity/minify";
import { FeatureUtility } from "../model/utility/feature.js";
import { defineCustomElementLoader } from "./feature.js";
import { rootNamespace } from "./root.js";
import { REGISTRY_ELEMENT } from "../model/resource.js";
import { lookup } from "./lookup.js";
import { isString } from "@acng/frontend-bounty";
import { NamespaceUtility } from "../index.js";
/**
 * @param {FeatureUtility | HTMLTemplateElement | null} feature
 * @param {string} name
 * @param {typeof import("../model/widget.js").Widget} CustomWidget
 */
export function defineCustomWidget(feature, name, CustomWidget) {
    const namespaceElement = (feature instanceof FeatureUtility ? feature[REGISTRY_ELEMENT] : feature) ?? rootNamespace;
    if (isString(CustomWidget.template)) {
        const namespace = new NamespaceUtility(namespaceElement);
        namespace.insert(CustomWidget.template, name);
        CustomWidget.template = true;
    }
    const templatePath = CustomWidget.template === true ? [name] : CustomWidget.template;
    defineCustomElementLoader(namespaceElement, name, async () => {
        for (const consumable of CustomWidget.consumables) {
            consumable[CTX_SUBSCRIBE_TAGNAME](name);
        }
        return CustomWidget;
    }, async () => {
        if (templatePath) {
            CustomWidget[REGISTRY_ELEMENT] = await lookup(namespaceElement, templatePath);
        }
        await CustomWidget.setup();
    });
}
